// extracted by mini-css-extract-plugin
module.exports = {"root":"Views_root__1onxh"};